import skuConversionUtils from '../skuconversion';
import _join from 'lodash/join';
import _isArray from 'lodash/isArray';
import _get from 'lodash/get';

const getInitColors = sku => [
  {
    color: sku ? sku.color : undefined,
    colorIntensity: sku ? Number(sku.colorIntensity) : 0,
  },
];

export const initLookPattern = {
  LIPCOLOR: {
    colors: getInitColors(),
  },
  BLUSH: {colors: getInitColors()},
  EYELASHES: {
    colors: getInitColors(),
  },
  EYELINER: {colors: getInitColors()},
  EYESHADOW: {colors: getInitColors()},
  FOUNDATION: {
    colors: getInitColors(),
  },
  MASCARA: {
    colors: getInitColors(),
  },
};

const getLookPattern = (patterns = []) => {
  let lookPattern = {...initLookPattern};
  const types = Object.keys(lookPattern);
  types.forEach(type => {
    const pattern = patterns.find(pattern => pattern.sku.skuType === type);
    const sku = skuConversionUtils.fromDb(_get(pattern, 'sku', {}));
    const colorIntensities = _get(pattern, 'colorIntensities', '').split(',');
    lookPattern[type] = {
      colors: getInitColors(sku),
      ...sku,
    };
    colorIntensities.forEach((ci, i) => {
      if (!lookPattern[type].colors[i]) lookPattern[type].colors[i] = {};
      lookPattern[type].colors[i].colorIntensity = Number(ci);
    });
  });
  return lookPattern;
};

const _fromObject = v => ({
  id: v.id,
  lookNo: v.lookNo,
  lookName: v.i18n && v.i18n.enu && v.i18n.enu.lookName,
  patterns: v.patterns.map(p => ({
    ...skuConversionUtils.fromDb(p.sku),
  })),
  lookPattern: getLookPattern(v.patterns),
  lookStatus: v.lookStatus,
  createdTime: v.createdTime,
  lastModified: v.lastModified,
  enabled: v.lookStatus === 'ENABLED',
});

const _fromPageResult = v => ({
  totalSize: v.totalSize,
  results: v.results && !!v.results && v.results.map(vv => _fromObject(vv)),
});

const utils = {
  init: {
    lookNo: '',
    lookName: '',
    patterns: [],
    lookPattern: initLookPattern,
  },
  fromDb: v => (_isArray(v && v.results) ? _fromPageResult(v) : _fromObject(v)),
  toDb: v => ({
    look: {
      id: v.id,
      lookNo: v.lookNo,
      i18n: {
        enu: {
          lookName: v.lookName,
        },
      },
      patterns: Object.values(v.lookPattern)
        .filter(s => !!s.id)
        .map(p => {
          const colors = p.colors;
          return {
            sku: {
              id: p.id,
            },
            patternGuid: p.patternGuid,
            colorIndexes:
              colors && !!colors.length && _join(colors.map((_, i) => i), ','),
            colorIntensities:
              colors &&
              !!colors.length &&
              _join(colors.map(c => c.colorIntensity), ','),
          };
        }),
    },
  }),
  getInitColors: getInitColors,
};
export default utils;
